var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',_vm._g(_vm._b({staticClass:"card-shadow border-radius-xl",class:_vm.cardClass},'v-card',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_c('base-card-bottom',{attrs:{"titolo":_vm.titolo,"dettagli":_vm.dettagli}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }